import { useState } from 'react'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import ItemTabs from 'components/ItemTabs'
import Ledger from './Ledger'
import Config from './Config'
import { Container, PageTitle, InfoText } from './styles'

/*
  Repasse automático da Cutilei, visto pelo financeiro.

  Em página própria, e não como aba de `/admin/config`: aquela tela é o catálogo (serviços,
  produtos, cupons), e a chave que decide se dinheiro sai da conta da Cutilei não pertence ao
  mesmo lugar que um cupom promocional.
*/
export default function Payouts () {
  const [option, setOption] = useState (
    localStorage.getItem ('payout_option') ?? 'ledger'
  )

  const OPTION_LIST = [
    {label: 'Recebíveis', value: 'ledger', component: <Ledger/>},
    {label: 'Configuração', value: 'config', component: <Config/>}
  ]

  const selectedTab = OPTION_LIST.find (o => o.value === option) ?? OPTION_LIST[0]

  return (
    <Container>
      <AdminNavbar/>
      <PageTitle>Repasse automático</PageTitle>
      <InfoText align='center' style={{marginBottom: 14}}>
        O que a Cutilei deve aos salões e às manicures pelos atendimentos de membros
      </InfoText>
      <ItemTabs
        tabs={OPTION_LIST}
        selectedTab={selectedTab.value}
        onTabChange={tab => {
          setOption (tab)
          localStorage.setItem ('payout_option', tab)
        }}
        tabWidth={160}
      />
      {selectedTab.component}
    </Container>
  )
}
